import React, { useState, useEffect } from "react";
import PdfForm from "./PdfFrom";

const PdfUploader = () => {
  const [pdfList, setPdfList] = useState([]);
  const [view, setView] = useState("grid"); // grid | form
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("pdfUploads");
    if (stored) {
      setPdfList(JSON.parse(stored));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("pdfUploads", JSON.stringify(pdfList));
  }, [pdfList]);

  const handleDelete = (id) => {
    const updated = pdfList.filter((item) => item.id !== id);
    setPdfList(updated);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setView("form");
  };

  const handleCreate = () => {
    setEditingItem(null);
    setView("form");
  };

  const handleSave = (data) => {
    if (data.id) {
      setPdfList((prev) =>
        prev.map((item) => (item.id === data.id ? data : item))
      );
    } else {
      setPdfList((prev) => [...prev, { ...data, id: Date.now() }]);
    }
    setView("grid");
  };

  return (
    <div className="container mt-4">
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3 className="box-title">
                {view === "grid"
                  ? "Uploaded PDFs"
                  : editingItem
                  ? "Edit PDF"
                  : "Upload New PDF"}
              </h3>
              {view === "grid" ? (
                <button
                  className="btn btn-success btn-sm"
                  onClick={handleCreate}
                >
                  Upload New
                </button>
              ) : (
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => setView("grid")}
                >
                  Back to List
                </button>
              )}
            </div>

            {view === "grid" ? (
              
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Subject</th>
                      <th>File Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
               { pdfList.length === 0 ? (
                <tr>
              <td colSpan="4" className="text-center">
                No PDFs available.
              </td>
            </tr>
              ) : (
                    pdfList.map((item) => (
                      <tr key={item.id}>
                        <td>{item.className.toUpperCase()}</td>
                        <td>{item.subject}</td>
                        <td>{item.fileName}</td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm me-2"
                            onClick={() => handleEdit(item)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(item.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    )))}
                  </tbody>
                </table>
              )
             : (
              <PdfForm
                item={editingItem}
                onSave={handleSave}
                onCancel={() => setView("grid")}
              />
            )}
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};
export default PdfUploader;
